export default __webpack_public_path__ + "locales/ko-KR/Webhooks.json?hash=1ba03bfc53ecd60b68d0aedbc26d668a";